module.exports = __webpack_public_path__ + "media/images/games/clash-royale/elixir-705b50b21b43fc3e838337346ca95434.svg";